<template>
  <div>
    <div v-if="get_absen_loading" class="loading-container">
      <div class="loader"></div>
    </div>
    <div v-if="!get_absen_loading">
      <div>
        <div class="flex justify-between items-center border-b border-gray-100 px-0 pt-3 pb-3 m-0">
          <div class="flex-grow">
            <p class="playfair-display-400 text-base p-0 m-0">All Rekapan Absen Pegawai</p> 
          </div>
          <div class="mr-2">
            <el-select v-model="value_unit_kerja" placeholder="Pilih Unit Kerja" size="mini" style="width: 280px;" filterable clearable>
              <el-option
                v-for="(item, index) in unit_kerja"
                :key="index"
                :label="item.per_eselon_dua"
                :value="item.eselon_dua">
              </el-option>
            </el-select>
          </div>
          <div class="mr-2">
            <el-date-picker v-model="tanggal" type="date" size="mini" placeholder="Tanggal" style="width: 150px;"></el-date-picker>
          </div>
          <div class="ml-0.5">
            <el-button icon="el-icon-search" size="mini" @click="search_by_unit_and_date" circle></el-button>
          </div>
          <div class="ml-0.5">
            <el-button icon="el-icon-refresh" size="mini" @click="refresh_by_date" circle></el-button>
          </div>
          <div class="ml-0.5">
            <el-button icon="el-icon-download" size="mini" @click="export_excel" circle></el-button>
          </div>
          <div class="ml-0.5">
            <el-button icon="el-icon-map-location" size="mini" @click="open_dialogvisible_map(get_user.nip)" circle></el-button>
          </div>
        </div>
      </div>
      <!-- {{ get_user.eselonDua }} -->
      <div class="attendance-list">
        <div v-for="(item, index) in paginatedData" :key="index" class="attendance-item">
          <div class="item-row">
            <div class="employee-section">
              <span class="employee-name">{{ item?.nama }}</span>
              <span class="date-text">{{ item?.tanggal | konversi_tanggal }}</span>
            </div>
            
            <div class="time-section">
              {{ item?.absenMasukSitkp | konversi_waktu }} - {{ item?.absenPulangSitkp | konversi_waktu }}
            </div>
            
            <div class="progress-section">
              {{ item?.progres == null ? 0 : item?.progres }}%
            </div>
            
            <div class="action-section">
              <button class="detail-btn" @click="open_dialogvisible(item)">
                Detail
              </button>
            </div>
          </div>
        </div>
        
        <!-- Empty state when no data found -->
        <div v-if="filteredData.length === 0" class="empty-state">
          <i class="el-icon-document" style="font-size: 48px; color: #ddd; margin-bottom: 16px;"></i>
          <p class="empty-text">Tidak ada data absensi</p>
          <p class="empty-subtext">Pilih unit kerja dan tanggal, lalu klik tombol search</p>
        </div>
      </div>

      <!-- Pagination -->
      <div class="pagination-container" v-if="filteredData.length > 0">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper, total"
          :total="filteredData.length">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="Detail" :visible.sync="dialogvisible" width="50%" top="10vh">
      <!-- {{ absen }} -->
      <div>
        <div class="flex justify-between items-center border-b border-gray-100 px-0 pt-0 pb-2.5 m-0">
          <div class="flex-grow">
            <p class="text-gray-600 text-xs text-left roboto-light p-0 m-0">{{ absen.tanggal | konversi_tanggal }}</p>
            <p class="titillium-web-regular p-0 m-0">{{ absen.nama }}</p>
          </div>
          <div class="w-44">
            <p class="text-gray-600 text-sm text-left roboto-light p-0 m-0">{{ absen.absenMasukSitkp | konversi_waktu }} - {{ absen.absenPulangSitkp | konversi_waktu }}</p> 
          </div>
          <div class="w-44 ml-4">
            <p class="text-gray-600 text-sm text-right roboto-light p-0 m-0">Progress {{ absen.progres == null ? 0 : absen.progres }}%</p> 
          </div>
        </div>
        <div class="px-0 pt-2.5 pb-2.5 m-0">
          <el-row>
            <el-col :span="3">
              <p class="text-gray-600 text-sm roboto-light p-0 m-0">Kegiatan</p>
            </el-col>
            <el-col :span="21">
              <p class="text-gray-400 text-sm text-justify roboto-light p-0 m-0">{{ absen.kegiatan == null ? 'Belum ada kegiatan' : absen.kegiatan }}</p>
            </el-col>
          </el-row>
          <el-row class="mt-2">
            <el-col :span="3">
              <p class="text-gray-600 text-sm roboto-light p-0 m-0">Output</p>
            </el-col>
            <el-col :span="21">
              <p class="text-gray-400 text-sm text-justify roboto-light p-0 m-0">{{ absen.output == null ? 'Belum ada output' : absen.output | format_output }}</p>
            </el-col>
          </el-row>
          <el-row class="mt-2">
            <el-col :span="3">
              <p class="text-gray-600 text-sm roboto-light p-0 m-0">Evidence</p>
            </el-col>
            <el-col :span="21">
              <p class="text-gray-400 text-sm text-justify roboto-light p-0 m-0">{{ absen.output == null ? 'Belum ada evidence' : absen.output | format_evidence }}</p>
            </el-col>
          </el-row>
        </div>
        <div>
          <l-map v-if="showMap" :zoom="zoom" :center="absen.koordinat_masuk" :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate" style="height:400px;width:100%;">
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker :lat-lng="absen.koordinat_masuk" v-if="absen.latitude != null && absen.longitude != null">
              <l-popup class="p-0 m-0">
                <div class="font-1">Absen Masuk</div>
              </l-popup>
            </l-marker>
            <l-marker :lat-lng="absen.koordinat_siang" v-if="absen.latitudeSiang != null && absen.longitudeSiang != null">
              <l-popup class="p-0 m-0">
                <div class="font-1">Absen Siang</div>
              </l-popup>
            </l-marker>
            <l-marker :lat-lng="absen.koordinat_pulang" v-if="absen.latitudePulang != null && absen.longitudePulang != null">
              <l-popup class="p-0 m-0">
                <div class="font-1">Absen Pulang</div>
              </l-popup>
            </l-marker>
          </l-map>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogvisible = false">Cancel</el-button> -->
        <!-- <el-button type="primary" @click="dialogvisible = false">Confirm</el-button> -->
      </span>
    </el-dialog>
    <el-dialog title="Kehadiran by Map" :visible.sync="dialogvisible_map" width="70%" top="10vh">
      <div>
          <!-- {{ get_user }} -->
          <!-- {{ get_info }} -->
          <l-map v-if="showMap" :zoom="zoom" :center="get_info" :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate" style="height:500px;width:100%;">
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker v-for="(item, index) in get_map" :key="index" :lat-lng="item.koordinat_masuk">
              <l-popup class="p-0 m-0">
                <div class="font-1">{{ item.nama }}</div>
              </l-popup>
            </l-marker>
          </l-map>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogvisible_map = false">Cancel</el-button> -->
        <!-- <el-button type="primary" @click="dialogvisible_map = false">Confirm</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import ingredients from '@/assets/json/ingredient.json'

import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  name: "AllRekapanView",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  data() {
    return {
      zoom: 13,
      center: latLng(47.41322, -1.219482),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: 11.5,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: { zoomSnap: 0.5 },
      showMap: true,
      tanggal: moment(new Date()).format("YYYY-MM-DD"),
      today: moment(new Date()).format("YYYY-MM-DD"),
      loading: false,
      dialogvisible: false,
      dialogvisible_map: false,
      absen: {},
      nip: null,
      currentPage: 1,
      pageSize: 10,
      unit_kerja: ingredients.records,
      value_unit_kerja: null,
    }
  },
  filters: {
    konversi_tanggal: function(value){
      moment.locale('id'); 
      return moment(value).format('dddd')+', '+moment(value).format('LL');
    },
    konversi_waktu: function(value){
      moment.locale('id'); 
      return value === null ? 'Belum Absen' : moment(value).format('HH.mm');
    },
    format_output: function(value) {
      if (value != null) {
        let abc = value.split("@");
        return abc[0];
      }
      return "Belum ada";
    },
    format_evidence: function(value) {
      if (value != null) {
        let abc = value.split("@");
        return abc[1];
      }
      return "Belum ada";
    },
  },
  computed: {
    get_info() {
      // return this.$store.state.absen.map.filter(text => new RegExp(this.nip).test(text.nip))

      const filteredData = this.$store.state.absen.map;

      const koordinatMasuk = filteredData.length > 0 ? filteredData[0].koordinat_masuk : null;
      // console.log(this.$store.state.absen.map);
      return koordinatMasuk;
     
    },
    get_user() {
      return this.$store.state.user.user
    },
    get_absen() {
      const absen = this.$store.state.absen.absen;
      console.log('get_absen computed:', absen, 'Length:', absen?.length);
      return Array.isArray(absen) ? absen : [];
    },
    get_map() {
      return this.$store.state.absen.map
    },
    get_absen_loading() {
      return this.$store.state.absen.loading
    },
    filteredData() {
      const data = this.get_absen;
      // console.log('filteredData:', data.length, 'items');
      return data;
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      const paginated = this.filteredData.slice(start, end);
      // console.log('paginatedData:', paginated.length, 'items from', this.filteredData.length, 'total');
      return paginated;
    }
  },
  created() {
    // this.$store.dispatch('absen/get_rekapan', {tanggal: this.tanggal})
    // Initial load - dapat dikomentari jika tidak ingin auto-load
    // this.$store.dispatch('absen/get_rekapan_by_unit', {tanggal: this.tanggal, unitKerja: 'STIA.3.1'})
    this.$store.dispatch('user/get_user')
    // this.$store.dispatch('get_roles')
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    search_by_date: function() {
      this.loading = true;
      this.$store.dispatch('absen/get_rekapan', {tanggal: this.tanggal})
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false; 
      })
    },
    refresh_by_date: function() {
      this.loading = true;
      this.$store.dispatch('absen/get_rekapan', {tanggal: this.today})
      .then(() => {
        this.loading = false;
        this.tanggal = moment(new Date()).format("YYYY-MM-DD");
        this.today = moment(new Date()).format("YYYY-MM-DD");
      })
      .catch(() => {
        this.loading = false; 
      })
    },
    open_dialogvisible: function(value) {
      this.dialogvisible = true;
      this.absen = value;
      // console.log(value);
    },
    open_dialogvisible_map: function(value) {
      this.dialogvisible_map = true;
      this.nip = value;
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    },
    export_excel() {
      if (!this.value_unit_kerja) {
        this.$message.warning('Pilih unit kerja terlebih dahulu');
        return;
      }
      if (!this.tanggal) {
        this.$message.warning('Pilih tanggal terlebih dahulu');
        return;
      }

      this.$store.dispatch('absen/export_daftar_unit_tanggal', {
        unitKerja: this.value_unit_kerja,
        tanggal: this.tanggal
      })
      .then(() => {
        this.$message.success('File Excel berhasil diunduh');
      })
      .catch(() => {
        this.$message.error('Gagal mengunduh file Excel');
      });
    },
    search_by_unit_and_date() {
      if (!this.value_unit_kerja) {
        this.$message.warning('Pilih unit kerja terlebih dahulu');
        return;
      }
      if (!this.tanggal) {
        this.$message.warning('Pilih tanggal terlebih dahulu');
        return;
      }

      console.log('Searching with:', {
        unitKerja: this.value_unit_kerja || this.get_user.eselonDua,
        tanggal: this.tanggal
      });

      this.loading = true;

      this.$store.dispatch('absen/get_rekapan_by_unit', {
        unitKerja: this.value_unit_kerja || this.get_user.eselonDua,
        tanggal: this.tanggal
      })
      .then((response) => {
        console.log('API Response:', response);
        console.log('Store absen state after dispatch:', this.$store.state.absen);
        this.loading = false;
        this.currentPage = 1;
        const totalRecords = this.$store.state.absen.absen?.length || 0;
        this.$message.success(`Data berhasil dimuat: ${totalRecords} records`);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.loading = false;
        this.$message.error('Gagal memuat data: ' + (error.message || 'Terjadi kesalahan'));
      });
    },
  },
}
</script>

<style scoped>
/* Loading styles */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.loader {
  border: 4px solid #f3f4f6;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Simple list styles */
.attendance-list {
  padding: 16px;
  max-width: 900px;
  margin: 0 auto;
}

.attendance-item {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
}

.attendance-item:hover {
  border-color: #3b82f6;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
}

.item-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 16px;
}

.employee-section {
  flex: 2;
  min-width: 0;
}

.employee-name {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  display: block;
}

.date-text {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  display: block;
}

.time-section {
  flex: 1;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  text-align: center;
}

.progress-section {
  flex: 0 0 60px;
  font-size: 13px;
  color: #3b82f6;
  font-weight: 600;
  text-align: center;
}

.action-section {
  flex: 0 0 80px;
}

.detail-btn {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.detail-btn:hover {
  background: #2563eb;
}

/* Pagination styles */
.pagination-container {
  display: flex;
  justify-content: center;
  /* padding: 0px 20px 20px 20px; */
}

/* Responsive design */
@media (max-width: 768px) {
  .attendance-list {
    padding: 12px;
  }
  
  .item-row {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    padding: 12px;
  }
  
  .employee-section,
  .time-section,
  .progress-section,
  .action-section {
    flex: none;
  }
  
  .time-section {
    text-align: left;
    font-size: 13px;
  }
  
  .progress-section {
    text-align: left;
  }
  
  .detail-btn {
    width: 100%;
    padding: 10px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .employee-name {
    font-size: 14px;
  }
  
  .date-text {
    font-size: 11px;
  }
  
  .time-section {
    font-size: 12px;
  }
  
  .progress-section {
    font-size: 12px;
  }
}

/* Simple fade animation */
.attendance-item {
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Empty state */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #6b7280;
}

.empty-text {
  font-size: 16px;
  color: #374151;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.empty-subtext {
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
}

.attendance-list:empty::after {
  content: 'Tidak ada data absensi';
  display: block;
  text-align: center;
  color: #6b7280;
  padding: 40px;
  font-style: italic;
}
</style>